/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  var BUTTON_SUCCESS_MESSAGE = 'YOUR ORDER HAS BEEN ADDED TO CART!';
  var BUTTON_SIZE_WARNING_MESSAGE = 'Please select a door size!';
  var BUTTON_SUCCESS_MS = 2000;
  var BUTTON_FADE_MS = 220;
  var RESET_DELAY_MS = BUTTON_SUCCESS_MS;
  var cartIndicatorRefreshTimer = null;

  function getCartJsonUrl() {
    var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
    var normalizedCartUrl = String(cartUrl).replace(/\/$/, '');
    return normalizedCartUrl + '.js';
  }

  function updateHeaderCartIndicators(itemCount) {
    var hasItems = Number(itemCount) > 0;
    var toggles = document.querySelectorAll('.cart__toggle');
    toggles.forEach(function(toggle) {
      toggle.classList.toggle('cart__toggle--has-items', hasItems);
    });
  }

  function updateSubtotalItemCount(itemCount) {
    var count = Number(itemCount);
    if (!Number.isFinite(count)) return;
    var label = count === 1 ? '1 item' : count + ' items';
    document.querySelectorAll('[data-cart-subtotal-count]').forEach(function(el) {
      el.textContent = label;
    });
  }

  function refreshHeaderCartIndicators() {
    fetch(getCartJsonUrl(), {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        if (!cart || typeof cart.item_count === 'undefined') return;
        updateHeaderCartIndicators(cart.item_count);
        updateSubtotalItemCount(cart.item_count);
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  function scheduleHeaderCartIndicatorsRefresh() {
    if (cartIndicatorRefreshTimer) {
      clearTimeout(cartIndicatorRefreshTimer);
    }

    cartIndicatorRefreshTimer = setTimeout(function() {
      refreshHeaderCartIndicators();
    }, 120);
  }

  function openCartDrawerOnAdd() {
    var cartDrawer = document.querySelector('cart-element[data-cart-drawer]');
    if (!cartDrawer || typeof cartDrawer.openCartDrawer !== 'function') return;
    cartDrawer.openCartDrawer();
  }

  function getHeaderOffset() {
    if (typeof window.stickyHeaderHeight === 'number' && window.stickyHeaderHeight > 0) {
      return window.stickyHeaderHeight;
    }

    var cssVar = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var parsed = parseInt(cssVar, 10);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function smoothScrollToProductTop(productInfo) {
    if (!productInfo || typeof productInfo.getBoundingClientRect !== 'function') return;

    var targetY = productInfo.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset() - 20;
    window.scrollTo({ top: Math.max(targetY, 0), behavior: 'smooth' });
  }

  function getButtonTextTarget(button, textEl) {
    return textEl || button;
  }

  function setTextContent(target, value, isHtml) {
    if (isHtml) {
      target.innerHTML = value;
      return;
    }

    target.textContent = value;
  }

  function fadeSwapButtonText(target, value, isHtml, done) {
    target.style.transition = 'opacity ' + BUTTON_FADE_MS + 'ms ease';
    target.style.opacity = '0';

    setTimeout(function() {
      setTextContent(target, value, isHtml);
      target.style.opacity = '1';

      if (typeof done === 'function') {
        done();
      }
    }, BUTTON_FADE_MS);
  }

  function showButtonAddedState(detail) {
    if (!detail || !detail.button) return;

    var button = detail.button;
    var textEl = detail.textEl || button.querySelector('[data-add-to-cart-text]');
    clearDoorBuilderSizeWarning(button.form || button.closest('form'));
    var target = getButtonTextTarget(button, textEl);
    var originalText = detail.originalText || (textEl ? textEl.innerHTML : button.innerHTML);
    var restoreAsHtml = !textEl || /</.test(originalText);
    var existingTimer = button.__exosAddedTimer || null;

    if (existingTimer) {
      clearTimeout(existingTimer);
    }

    button.classList.remove('is-loading');
    button.classList.add('is-success');
    button.setAttribute('disabled', 'disabled');

    fadeSwapButtonText(target, BUTTON_SUCCESS_MESSAGE, false);

    button.__exosAddedTimer = setTimeout(function() {
      fadeSwapButtonText(target, originalText, restoreAsHtml, function() {
        button.classList.remove('is-success');
        button.removeAttribute('disabled');
      });
    }, BUTTON_SUCCESS_MS);
  }

  function isDoorBuilderProductInfo(productInfo) {
    // Double-door pairs use their own sheet ([data-double-door-sheet]) but need
    // the same no-preselected-size behavior: nobody should be able to add a
    // door without consciously picking its size.
    return Boolean(
      productInfo &&
        productInfo.querySelector('[data-door-addon-configurator], [data-double-door-sheet], [data-prehung-kit]')
    );
  }

  function getDoorBuilderContextFromButton(button) {
    if (!button) return null;
    var productForm = button.closest('product-form');
    var productInfo = productForm ? productForm.closest('product-info') : null;
    if (!productForm || !isDoorBuilderProductInfo(productInfo)) return null;
    var nativeForm = button.form || productForm.querySelector('form');
    var configurator = productInfo.querySelector('[data-door-addon-configurator]');
    var formId = '';

    if (nativeForm && nativeForm.id) {
      formId = nativeForm.id;
    } else if (configurator && configurator.dataset && configurator.dataset.productFormId) {
      formId = configurator.dataset.productFormId;
    }

    return {
      productForm: productForm,
      productInfo: productInfo,
      formId: formId
    };
  }

  function setDoorBuilderSubmitDisabled(productForm, disabled) {
    if (!productForm) return;

    var submitButton = productForm.querySelector('[type="submit"][name="add"]');
    if (!submitButton) return;

    if (disabled) {
      submitButton.setAttribute('disabled', 'disabled');
    } else if (!submitButton.classList.contains('is-loading') && !submitButton.classList.contains('is-success')) {
      submitButton.removeAttribute('disabled');
    }
  }

  function clearDoorBuilderSizeWarning(productForm) {
    if (!productForm) return;
    var submitButton = productForm.querySelector('[type="submit"][name="add"]');
    if (!submitButton) return;

    var textEl = submitButton.querySelector('[data-add-to-cart-text]');
    if (!textEl) return;

    textEl.classList.remove('is-size-warning');
    textEl.removeAttribute('data-size-warning-text');
  }

  function showDoorBuilderSizeWarning(productForm) {
    if (!productForm) return;
    var submitButton = productForm.querySelector('[type="submit"][name="add"]');
    if (!submitButton) return;

    var textEl = submitButton.querySelector('[data-add-to-cart-text]');
    if (!textEl) return;

    submitButton.classList.remove('is-loading');
    submitButton.classList.remove('is-success');
    submitButton.removeAttribute('disabled');

    textEl.classList.add('is-size-warning');
    textEl.setAttribute('data-size-warning-text', BUTTON_SIZE_WARNING_MESSAGE);
  }

  function isDoorBuilderReadyToSubmit(productInfo, productForm) {
    if (!productInfo || !productForm) return false;

    var hasSelectedOption = Boolean(
      productInfo.querySelector('.radio__input[data-single-option-selector]:checked, .swatch__input[data-single-option-selector]:checked')
    );
    var variantIdInput = productForm.querySelector('input[name="id"]');
    var hasVariantId = Boolean(variantIdInput && variantIdInput.value);

    return hasSelectedOption && hasVariantId;
  }

  function isDoorBuilderUnavailable(productInfo) {
    if (!productInfo) return false;

    var formWrapper = productInfo.querySelector('[data-form-wrapper]');
    if (!formWrapper) return false;

    return (
      formWrapper.classList.contains('variant--soldout') ||
      formWrapper.classList.contains('variant--unavailable')
    );
  }

  function clearDoorBuilderVariantSelection(productInfo, productForm) {
    if (!productInfo || !productForm) return;

    productInfo
      .querySelectorAll('.radio__input[data-single-option-selector], .swatch__input[data-single-option-selector]')
      .forEach(function(input) {
        input.checked = false;
        input.removeAttribute('checked');
      });

    // Exos ordered-in (2026-09-14): the callout and the stock badge describe the selected size.
    // With the selection cleared they must not show; the next size pick re-renders both fresh.
    productInfo
      .querySelectorAll('[data-exos-ordered-in], .exos-countdown--ordered-in')
      .forEach(function(el) {
        el.setAttribute('hidden', '');
      });

    var variantIdInput = productForm.querySelector('input[name="id"]');
    if (variantIdInput) {
      variantIdInput.value = '';
      variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var submitButton = productForm.querySelector('[type="submit"][name="add"]');
    if (submitButton) {
      submitButton.classList.remove('is-loading');
      submitButton.classList.remove('is-success');
    }

    clearDoorBuilderSizeWarning(productForm);
    setDoorBuilderSubmitDisabled(productForm, isDoorBuilderUnavailable(productInfo));
  }

  function syncDoorBuilderSubmitState(productInfo, productForm) {
    if (!productInfo || !productForm) return;

    if (isDoorBuilderUnavailable(productInfo)) {
      clearDoorBuilderSizeWarning(productForm);
      setDoorBuilderSubmitDisabled(productForm, true);
      return;
    }

    if (isDoorBuilderReadyToSubmit(productInfo, productForm)) {
      clearDoorBuilderSizeWarning(productForm);
    }

    // Keep button visually active even when no size is selected.
    setDoorBuilderSubmitDisabled(productForm, false);
  }

  function initDoorBuilderNoSelection(scope) {
    var root = scope || document;
    var productInfos = root.matches && root.matches('product-info')
      ? [root]
      : Array.prototype.slice.call(root.querySelectorAll('product-info'));

    productInfos.forEach(function(productInfo) {
      if (!isDoorBuilderProductInfo(productInfo)) return;
      if (productInfo.hasAttribute('data-exos-doorbuilder-init')) return;

      var productForm = productInfo.querySelector('product-form');
      if (!productForm) return;

      productInfo.setAttribute('data-exos-doorbuilder-init', 'true');
      clearDoorBuilderVariantSelection(productInfo, productForm);

      var onStateChange = function() {
        setTimeout(function() {
          syncDoorBuilderSubmitState(productInfo, productForm);
        }, 0);
      };

      productInfo.addEventListener('change', onStateChange);
      productInfo.addEventListener('input', onStateChange);
    });
  }

  function resetDoorBuilderConfiguratorByFormId(formId) {
    if (!formId) return;

    document.dispatchEvent(
      new CustomEvent('exos:door-configurator:reset', {
        bubbles: true,
        detail: { formId: formId }
      })
    );
  }

  function scheduleDoorBuilderReset(detail) {
    var context = getDoorBuilderContextFromButton(detail && detail.button);
    if (!context) return;

    setTimeout(function() {
      smoothScrollToProductTop(context.productInfo);
      clearDoorBuilderVariantSelection(context.productInfo, context.productForm);
      syncDoorBuilderSubmitState(context.productInfo, context.productForm);
      resetDoorBuilderConfiguratorByFormId(context.formId);
    }, RESET_DELAY_MS);
  }

  function patchProductFormNoRedirect() {
    var ProductForm = window.customElements && window.customElements.get('product-form');
    if (!ProductForm || !ProductForm.prototype) return;
    if (ProductForm.prototype.__exosNoRedirectPatched) return;

    ProductForm.prototype.__exosNoRedirectPatched = true;

    ProductForm.prototype.addToCart = function(data, variantTitle) {
      var variantName = variantTitle || '';
      var doorBuilderContext = getDoorBuilderContextFromButton(this.submitButton);

      if (doorBuilderContext && isDoorBuilderUnavailable(doorBuilderContext.productInfo)) {
        setDoorBuilderSubmitDisabled(doorBuilderContext.productForm, true);
        clearDoorBuilderSizeWarning(doorBuilderContext.productForm);
        return;
      }

      if (doorBuilderContext && !isDoorBuilderReadyToSubmit(doorBuilderContext.productInfo, doorBuilderContext.productForm)) {
        showDoorBuilderSizeWarning(doorBuilderContext.productForm);
        return;
      }

      if (this.submitButton) {
        this.submitButton.classList.add('is-loading');
        this.submitButton.setAttribute('disabled', true);
      }

      fetch(theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript',
        },
        body: data,
      })
        .then(function(response) {
          return response.json();
        })
        .then(
          function(response) {
            if (response.status) {
              this.addToCartError(response);
              this.submitButton.classList.remove('is-loading');
              this.submitButton.removeAttribute('disabled');
              document.dispatchEvent(new CustomEvent('theme:cart-bar:reset-atc-animation', { bubbles: true }));
              if (!this.showCannotAddMoreInCart) return;
            }

            this.hideAddToCartErrorMessage();

            // Keep user on-page: refresh cart state instead of redirecting to /cart.
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
            document.dispatchEvent(
              new CustomEvent('exos:cart:added', {
                bubbles: true,
                detail: {
                  source: 'product-form',
                  button: this.submitButton,
                  textEl: this.submitButtonText,
                  originalText: this.submitButtonText ? this.submitButtonText.innerHTML : ''
                },
              })
            );

            if (this.showCannotAddMoreInCart) {
              document.dispatchEvent(
                new CustomEvent('theme:cart:error', {
                  bubbles: true,
                  detail: { variantTitle: variantName },
                })
              );
            }
          }.bind(this)
        )
        .catch(function(error) {
          if (this.submitButton) {
            this.submitButton.classList.remove('is-loading');
            this.submitButton.removeAttribute('disabled');
          }
          document.dispatchEvent(new CustomEvent('theme:cart-bar:reset-atc-animation', { bubbles: true }));
          console.log(error);
        }.bind(this));
    };
  }

  function init() {
    patchProductFormNoRedirect();
    initDoorBuilderNoSelection(document);

    document.addEventListener('exos:cart:added', function(event) {
      openCartDrawerOnAdd();
      showButtonAddedState(event.detail || {});
      scheduleHeaderCartIndicatorsRefresh();
      scheduleDoorBuilderReset(event.detail || {});
    });

    // Keep the subtotal item count in sync after any cart mutation
    // (quantity change on cart page, remove, drawer add, etc.)
    document.addEventListener('theme:cart:update', scheduleHeaderCartIndicatorsRefresh);
    document.addEventListener('theme:cart:refresh', scheduleHeaderCartIndicatorsRefresh);
    document.addEventListener('theme:cart:loaded', scheduleHeaderCartIndicatorsRefresh);
    document.addEventListener('theme:cart:added', scheduleHeaderCartIndicatorsRefresh);

    document.addEventListener('theme:product-info:loaded', function(event) {
      initDoorBuilderNoSelection(event.target || document);
    });

    document.addEventListener('shopify:section:load', function(event) {
      initDoorBuilderNoSelection(event.target || document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
